export default __webpack_public_path__ + "media/images/twitter-f47de6c0a9734becb0c318cba351ac7e.svg";